
import ContainerHeader from "components/ContainerHeader"
import { connect } from "react-redux"
import { useEffect, useState } from "react"
import API from 'util/Api'
import CardBox from "components/CardBox"
import PopUpDialog from "components/PopUpDialog";
import ReportFilter from "components/ReportTable/ReportFilter"
import moment from "moment"
import _ from "lodash"
import ReportTable from "components/ReportTable"
import { Grid, TextField, LinearProgress } from "@material-ui/core"

const DialogBox = ({ clicked, setDialogData }) => {
    const [formData, setFormData] = useState({
        id: clicked.id_hidden,
        clockOut: moment().format("YYYY-MM-DDTHH:mm"),
    });

    const minDateTime = clicked.clock_in_hidden
        ? moment(clicked.clock_in_hidden, "DD/MM/YYYY hh:mm A").format("YYYY-MM-DDTHH:mm")
        : undefined;

    const maxDateTime = moment().format("YYYY-MM-DDTHH:mm");

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <TextField
                    label="Clock Out Time"
                    type="datetime-local"
                    value={formData.clockOut}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    inputProps={{
                        min: minDateTime,
                        max: maxDateTime,
                    }}
                    onChange={(e) => {
                        const updated = { ...formData, clockOut: e.target.value };
                        setFormData(updated);
                        setDialogData({ ...formData, clockOut: e.target.value });
                    }}
                />
            </Grid>
        </Grid>
    );
};

const Attendance = (props) => {
    const reportFlags = _.find(props?.reportFlags, { name: 'attendance' })?.flags;
    console.log("reportFlags", reportFlags) 
    const [valetLocations, setValetLocations] = useState([])
    const [table, setTable] = useState({})
    const [dialogData, setDialogData] = useState({})
    const [loading, setLoading] = useState(false)
    const [dialog, setDialog] = useState({
        open: false,
        content: "",
        header: "",
        agreeBtnTxt: "",
        disAgreeBtnTxt: "",
    })

    useEffect(() => {
        API.get("valetLocations").then((res) => {
            let valetLoc = [];
            res.data.data.table.body.map((loc) => {
                let tempLoc = { id: loc.id.value, name: loc.name.value };
                valetLoc.push(tempLoc);
            })
            setValetLocations(valetLoc)
        })
    }, [])

    const getReportData = (params, cb) => {
        params.type = 'attendance'
        setLoading(true)
        API.get("reportDetails?data=" + JSON.stringify(params)).then((res) => {
            setTable(res.data.data || {})
        }).catch(err => {
            setTable({})
        }).finally(() => {
            setLoading(false)  
            cb()               
        })
    }

    const submitClockout = () => {
        console.log("submitClockout called with dialogData:", dialogData);
        if (Object.keys(dialogData).length > 0) {
            API.put("clockout", JSON.stringify(dialogData))
                .then((res) => {
                    handleDialogClose();
                })
                .catch((err) => {
                    console.log("error", err);
                    handleDialogClose();
                });
        }
    }

    const handleDialogClose = () => {
        setDialog({
            open: false,
            content: "",
            header: "",
            agreeBtnTxt: "",
            disAgreeBtnTxt: "",
        });
    }

    const markClockOut = (clicked) => {
        setDialog({
            clicked: clicked,
            open: true,
            content: (
                <DialogBox clicked={clicked} setDialogData={setDialogData} />
            ),
            header: "Mark Clock Out",
            agreeBtnTxt: "Clock Out",
            disAgreeBtnTxt: "Cancel",
        });
        setDialogData({
            id: clicked.id_hidden,
            clockOut: moment().format("YYYY-MM-DDTHH:mm"),
        });
    }

    return (
        <>
            <ContainerHeader title={"Attendance Report"} />
            { loading && <div className='w-100'><LinearProgress color="primary" /></div> }
            <div className="row">
                <CardBox styleName="col-12">
                    <ReportFilter
                        locations={[]}
                        valetLocations={valetLocations}
                        reportType={['attendance']}
                        requestStatus={{ msg: "", success: true }}
                        getReportData={getReportData}
                        flags={reportFlags}
                        vendors={[]}
                    />
                </CardBox>
                {table && Object.keys(table).length > 0 && (
                    <ReportTable
                        downloadCSVBtn
                        data={table}
                        markClockOut={markClockOut}
                    />
                )}
            </div>
            <PopUpDialog
                fullWidth
                open={dialog.open}
                header={dialog.header}
                content={dialog.content}
                agreeBtnTxt={dialog.agreeBtnTxt}
                disAgreeBtnTxt={dialog.disAgreeBtnTxt}
                agreeClicked={submitClockout}
                handleDialogClose={handleDialogClose}
            />
        </>
    )
}

const mapStateToProps = function (state) {
    try {
        return {
            reportFlags: _.concat(
                state.auth.authUser.users
            ),
            dashboardActions: state.auth.authUser.dashboardactions,
        };
    } catch (err) { }
}

export default connect(mapStateToProps)(Attendance);